/**
 * Configuration Mapping Module
 * Contains application-wide constants, API response codes, polling durations,
 * and metadata field mappings for contract overview display
 */

/** Application product name displayed in UI */
export const PRODUCT_NAME = "ContractGenie <sup>TM</sup>" 

/** HTTP 200 - Successful API response code */
export const API_SUCCESS_RESPONSE_CODE= 200

/** HTTP 201 - Resource created successfully response code */
export const API_SUCCESS_RESPONSE_CREATED_CODE= 201

/** HTTP 401 - Unauthorized/authentication failure response code */
export const API_AUTHORIZATION_CODE= 401

/** Application client identifier from environment variables */
export const APP_CLIENT = process.env.REACT_APP_CLIENT

/** Contract status check polling interval in milliseconds (30 seconds) */
export const CONTRACT_STATUS_CHECK_POLLING_DURATION = 30000   //Milliseconds

/** Authentication token refresh interval in milliseconds (15 minutes) */
export const AUTH_TOKEN_REFRESH_DURATION = 900000  //Milliseconds

/** Maximum number of contract status polling attempts */
export const CONTRACT_POLLING_MAX_COUNT = 50 

/**
 * Metadata field mappings for contract overview display
 * Maps backend field names to display labels and stores their values
 * Each field has a label (displayed to user) and value (populated at runtime)
 */
export const OVERVIEW_META_DATA  = {
   "FilePath":{
     "label":"TITLE",
     "value":""   
    },
    "DocumentNo":{
        "label":"DOCUMENT NO",
        "value":""   
    },
    "ContractID":{
        "label":"DOCUMENT NO",
        "value":""   
    },
    "documenttype":{
        "label":"DOCUMENT TYPE",
        "value":""   
    },  
    "licensor":{
        "label":"PARTY1",
        "value":""   
    }, 
    "version":{
        "label":"Version",
        "value":""   
    },
    "effectivedate":{
        "label":"EFFECTIVE DATE",
        "value":""   
    },
    "expirationdate":{
        "label":"EXPIRY DATE",
        "value":""   
    },
    "sell-off period":{
        "label":"SELLOFF PERIOD",
        "value":"",
        "units":"days"    
    },
    "LicensorLegalName":{
        "label":"Licensor Name",
        "value":""   
    },
    "startdate":{
        "label":"Effective Date",
        "value":""   
    },
    "expirationdate":{
        "label":"Expiry Date",
        "value":""   
    },
    "PayableContact":{
        "label":"Payable To",
        "value":""   
    },
    
    
}